import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import styled from "styled-components";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import { DividerSpg } from "@duosoftbg/nacid-components";

const IconWrapper = styled.span`
  svg {
    width: 40px;
    height: 40px;
  }
`;

const CardTitle = styled.span`
  position: absolute;
  margin-left: 12px;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
`;

const RegistersCardWrapper = styled(Card)`
  height: 100%;

  &:hover {
    background: ${(props) => (props.theme.palette.mode === "dark" ? "rgba(6, 78, 148, 0.3)" : "#eee")};
  }
`;

const TextCard = ({ title, to = "/", icon, children }) => {
  const { t } = useTranslation();

  return (
    <NavLink to={to} style={{ textDecoration: "none" }}>
      <RegistersCardWrapper>
        <CardContent style={{ padding: "30px", paddingTop: "20px" }}>
          <Typography style={{ position: "relative" }} gutterBottom variant="h5" component="div">
            <IconWrapper>{icon}</IconWrapper>
            <CardTitle>{t(title)}</CardTitle>
          </Typography>
          <DividerSpg my={3} />
          <Box>{children}</Box>
        </CardContent>
      </RegistersCardWrapper>
    </NavLink>
  );
};

export default TextCard;
